import { getStoredSource, readSourceParam } from './attribution';

const AUTH_URL = import.meta.env.VITE_AUTH_SERVER || 'http://localhost:8787';

export type FunnelStep = 'landing_view' | 'app_view' | 'tailor_start' | 'tailor_complete';

/**
 * Record an anonymous funnel step, attributed to whatever sent the visitor.
 *
 * There are already two attribution rails and neither covers this. Signup
 * attribution fires only when someone creates an account, which almost nobody
 * does. GA4 would cover it, except the tags load at idle now to protect paint
 * time, so a visitor who leaves in one second - the measured average - is gone
 * before anything reports them.
 *
 * This has no dependencies and no queue: one beacon, sent immediately, that
 * survives the page being closed. It is the difference between "twenty people
 * came and left" and knowing which channel sent them and where they stopped.
 *
 * Fire-and-forget by construction. Nothing here is worth a broken page.
 */
export function trackFunnel(step: FunnelStep): void {
  try {
    const src = readSourceParam(location.search) || getStoredSource() || '';
    const payload = JSON.stringify({ step, src, viewport: window.innerWidth });
    const url = `${AUTH_URL}/auth/metric/funnel`;

    if (navigator.sendBeacon?.(url, new Blob([payload], { type: 'application/json' }))) return;
    void fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* a missing metric is never worth an error a user can see */
  }
}
